/* eslint-disable react/prop-types */
import React, { useCallback } from 'react';
import { Column, Pie, Bar } from '@ant-design/plots';

import { CapsuleStat, ChartCard, PosterWall, SectionCard } from '../../../ui';
import { boardMemberStoryPage } from '@/services/athenaBoard';
import styles from '../board.less';

/** 2. 会员画像（总量/性别/年龄/购买力/地域/痛点词云 + 成果海报） */
export const PortraitPane = ({
  data,
  tenantId,
  coachUserId,
  loading,
  error,
  onRetry,
}) => {
  const cardState = { loading, error, onRetry };
  /* 会员成果海报：2026-09-20 从 /memberPortrait 抽成独立分页接口
     （后端同步拆出 /athena/board/memberStoryPage），这里只需换取数函数 ——
     滚动、游标、加载态、空态都在 PosterWall（与打卡照片墙共用同一套形态）。 */
  const fetchPosters = useCallback(
    ({ lastId, limit }) =>
      boardMemberStoryPage({ tenantId, coachUserId, lastId, limit }).then(
        (r) => {
          if (!r || r.code !== '00000') {
            throw new Error((r && r.msg) || '会员成果海报加载失败');
          }
          return r.data;
        },
      ),
    [tenantId, coachUserId],
  );

  return (
    <>
      <div className={styles.chartRow3Wrap}>
        <SectionCard {...cardState} title="会员画像" subtitle="总量与本月新增">
          <div className={styles.capsuleStack}>
            <CapsuleStat
              label="总会员数"
              value={(data.summary || {}).totalMemberNum}
              tone="primary"
            />
            <CapsuleStat
              label="本月新增"
              value={(data.summary || {}).monthNewMemberNum}
              tone="success"
            />
          </div>
        </SectionCard>

        <SectionCard {...cardState} title="性别分布">
          <ChartCard
            height={220}
            empty={!(data.genderDistribution || []).length}
          >
            <Pie
              angleField="value"
              colorField="name"
              data={data.genderDistribution || []}
              radius={0.86}
              legend={{ position: 'bottom' }}
            />
          </ChartCard>
        </SectionCard>
        <SectionCard {...cardState} title="年龄分布">
          <ChartCard height={220} empty={!(data.ageDistribution || []).length}>
            <Column
              height={220}
              data={data.ageDistribution || []}
              xField="name"
              yField="value"
              legend={false}
            />
          </ChartCard>
        </SectionCard>
        <SectionCard {...cardState} title="购买力分层">
          <ChartCard height={220} empty={!(data.purchasingPower || []).length}>
            <Bar
              height={220}
              data={data.purchasingPower || []}
              xField="value"
              yField="name"
              legend={false}
            />
          </ChartCard>
        </SectionCard>

        <SectionCard {...cardState} title="地域分布">
          <ChartCard
            height={240}
            empty={!(data.regionDistribution || []).length}
          >
            <Bar
              height={240}
              data={data.regionDistribution || []}
              xField="value"
              yField="name"
              legend={false}
            />
          </ChartCard>
        </SectionCard>
        <SectionCard
          {...cardState}
          title="会员痛点词云"
          subtitle="组件库无词云组件，暂以权重条形呈现"
        >
          <ChartCard height={220} empty={!(data.painWordCloud || []).length}>
            <Bar
              height={220}
              data={data.painWordCloud || []}
              xField="weight"
              yField="name"
              legend={false}
            />
          </ChartCard>
        </SectionCard>
      </div>

      {/* 契约变更：源 CursorListModel 只有 {list, lastId}，没有总数 →
          不再展示「共 N 张」，只用 hasMore 决定还能不能继续拉（G7） */}
      <SectionCard
        {...cardState}
        title="会员成果海报"
        subtitle="横向滑动预览 · 滚动加载更多"
      >
        <PosterWall
          fetchPage={fetchPosters}
          resetKey={`${tenantId}-${coachUserId}`}
          emptyDescription="该教练暂无会员成果海报"
          emptyHint="会员完成里程碑或故事后可在此查看"
        />
      </SectionCard>
    </>
  );
};

export default PortraitPane;
